import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=dfda1bbe&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=dfda1bbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfda1bbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dfda1bbe')) {
      api.createRecord('dfda1bbe', component.options)
    } else {
      api.reload('dfda1bbe', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=dfda1bbe&scoped=true&", function () {
      api.rerender('dfda1bbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2b8DZu5Fk4WE6/JS/comp/GuestBox.vue"
export default component.exports